import Newsroom, { NewsroomProps } from "./Newsroom";

export { Newsroom, NewsroomProps };

export default Newsroom;
